export default __webpack_public_path__ + "static/media/overview-icon.028fe730.svg";